import React from "react";

interface IMinWidthProps{
    children?: React.ReactNode;
    width?: number;
    stretch?: boolean;
    hasFixValue?: boolean
}

export const MinWidth: React.FC<IMinWidthProps> = ({children, width = 800, stretch = false, hasFixValue = false})=>{
    return (
        <div style={{ width: stretch ? '100%' : hasFixValue ? `${width}px`:`min(100%, ${width}px)`}}>{children}</div>
    )
}